import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';
import {connect} from 'react-redux';
import ROUTES from './../../constants/routes';
import './../../css/acc-link.css';
import './../../global/css/acc-link-header-footer.css';
import './../../css/MultiCard.css';
import CardDetails from './CardDetails'
import alert from './../../images/alert.png';
import spinner from './../../Spinnerimage.gif';
import {Logo} from './../../components/common/Logo/Logo.js';
import {HttpStatusCode, ResultCodes} from './../../constants/utilities';
import {getMerchantData,onUserCancel,isRealPhoneNumber} from './../../constants/merchantData';
import AxiosDataService from '../../services/AxiosDataService';
import {OnMultiCardCancel,OnLinkingSuccess,OnMultiCardPageLoad,OnMulticardLinkError,OnMultiCardLinkNow} from './../../components/SiteCat/SiteCat'
import LinkContent from "../../components/common/privacydata/LinkContent";
import LinkContentPaypal from '../../components/common/privacydata/LinkContentPaypal';
import DiscoverCard from './../../images/discover-card.png';

class MultiCard extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      checkval: false,
      errorMsg: "",
      eligibleAccountVO: [],
      multicardresponse: "",
      doRedirect: false,
      pageName: "",
      isLoaded: false,
      submited: false,
      selectedCarddigits: "", 
      merchantName:"",
      authCode:""
    };
  }
  componentWillMount = () => {
    this.selectedCheckboxes = new Set();
    this.setState({
      merchantName : this.props.multiposts.merchant,
      authCode : this.props.multiposts.authcode
    });
  }
  //Link Now Click Event..
  handleFormSubmit = formSubmitEvent => {
       this.setState({
         isLoaded: true,
         submited: true
      })

    formSubmitEvent.preventDefault();
    let randomstring = require('random-string');
    const multiCardLinkId = this.state.multicardresponse.linkId
    const multiCardAccKey = this.state.multicardresponse.eligibleAccountVO
    let permittedValues = Array.from(this.selectedCheckboxes);
    var filtereddata = multiCardAccKey.filter(multiCardAccKey => {
      return permittedValues.includes(multiCardAccKey.accntKey)
    });
    const selectedCarddigits = (filtereddata.length > 0) ? filtereddata[filtereddata.length - 1].last4AcctNbr : "";
    this.setState({ selectedCarddigits: selectedCarddigits })
    const seletcardcount = permittedValues.length;
   
    let multiCardData = {
      accountKeys: permittedValues,
      linkId: multiCardLinkId,
      merchantName: this.state.merchantName,
      sessionID: this.props.multiposts.sessionID
    }

    if (!this.state.errorMsg && this.state.errorMsg !== "") {
      OnMultiCardLinkNow(seletcardcount, this.state.merchantName);
      const self = this;
        const options = {
        url: "linkFinancialInstrument",// + Config.env,
        method: "post",
        timeout: 8000,
        headers: {
          "Access-Control-Allow-Origin": "*",
          //"HTTP_AUTH_TOKEN": self.state.jwtTokenData,
          'Content-Type': 'application/json',
          "REQUEST_ID": randomstring({ length: 20 })
        },
        data: JSON.stringify(multiCardData)
      };
      AxiosDataService.fetch(options).then((responsedata) => {
          self.setState({
            isLoaded: false
          })
          let response=responsedata.data;
         

               //Storing Response in Reducer
        self.props.dispatch({
          type:'LINKFI_RESPONSE',
           response,
           selectedCarddigits: self.state.selectedCarddigits,
           last4Digit:self.state.last4Digit
          
          });
          if (response.responseOutput.returnCode === "0") {
            if (response.resultCode === ResultCodes.RA_DENY) {
              self.setState({
                pageName: "RaDeny",
                doRedirect: true
              });

            } else if (response.resultCode === ResultCodes.NO_CONTACT_CHNL) {
              self.setState({
                pageName: "NoContactChannel",
                doRedirect: true
              });

            } else if (response.resultCode === ResultCodes.CONTACT_SELECTION_PAGE) {
              self.setState({
                pageName: "ContactChannels",
                doRedirect: true
              });
  
            } else if (response.resultCode === ResultCodes.MERCHANT_REDIRECT_PAGE) {
              OnLinkingSuccess(this.state.merchantName);
              const redirecturl = response.partnerRedirectVO.href

              self.setState({
                pageName: "RedirectPage",
                doRedirect: true,
                isLoaded: true,
                locationhref: redirecturl
              });
            }  else if (response.resultCode === ResultCodes.CID_PAGE) {
            
              self.setState({
                pageName: "CardSecurePage",
                doRedirect: true
              });

            } else {
              self.setState({
                pageName: "noContactChannel",
                doRedirect: false
              });
            }
          } else {

          }
        },(errorResponse) => {
          self.setState({
            isLoaded: false
          })

          let error = errorResponse.response;
        

          let response=error.data;
         
          if (error.status === HttpStatusCode.INTERNAL_SERVER_ERROR || error.status === HttpStatusCode.NOT_FOUND) {

            
            self.setState({
              pageName: "TechDiff",
              doRedirect: true
            });

          } else if (error.statusText === "timeout" || error.status === 0) {
            
            self.setState({
              pageName: "TechDiff",
              doRedirect: true
            });
          } else if (response.returnCode === ResultCodes.TECH_DIFF_FI_DOWN || response.returnCode === ResultCodes.TECH_DIFF_RA_DOWN || response.returnCode === ResultCodes.TECH_DIFF_DPL_DOWN || response.returnCode === ResultCodes.TECH_DIFF_CACHE_DOWN || response.returnCode === ResultCodes.TECH_DIFF_NO_LINK_ACTIVITY) {
            self.setState({
              pageName: "TechDiff",
              doRedirect: true
            });
          } else {
            console.log("error else block");
          }
        
      }).catch((e)=>{
        console.log("API time out ");
        self.setState({
          pageName: "TechDiff",
          doRedirect: true
        });
      });
    } else {
      //  console.log("else part")
      this.setState({
        errorMsg: true,
        isLoaded: false
      });
      const ttlNoOfCards = this.state.eligibleAccountVO.length;
      const siteCatErrMsg =  'Please make your selection(s).';
      OnMulticardLinkError(siteCatErrMsg, ttlNoOfCards, this.state.merchantName);
    }

  }
  handleCancel = event => {
    OnMultiCardCancel(this.state.merchantName);
    let data = {
      merchantName: this.state.merchantName,
      cancelUrlData: this.state.cancelUrlData,
      authCode: this.state.authCode 
    }
    onUserCancel(data);
  }

  componentDidMount() {
    const loginresposnestate = this.props.multiposts.loginresponse
    
    const jwtTokenData = this.props.multiposts.jwtToken.jwtToken
    var cancelUrlData = null
    if (this.state.merchantName === 'amazon') {
       cancelUrlData = this.props.multiposts.cancelUrl
    }else {
       cancelUrlData = this.props.multiposts.jwtToken.cancelUrl
    }
    this.setState({
      multicardresponse: loginresposnestate,
      eligibleAccountVO: loginresposnestate.eligibleAccountVO,
      jwtTokenData,
      cancelUrlData,
      last4Digit:this.props.multiposts.last4Digit
    });
  
  const NumberOfCards = loginresposnestate.eligibleAccountVO.length;
  OnMultiCardPageLoad(NumberOfCards, this.state.merchantName);

  }
  //Validate the checkbox click..
  toggleChange = (e) => {
    if (this.state.merchantName == "paypal"){
      let chkboxvalue = e.target.value
      if (this.selectedCheckboxes.has(chkboxvalue)) {
        this.selectedCheckboxes.delete(chkboxvalue)
      }else {
        this.selectedCheckboxes.add(chkboxvalue)
      }
    }
    else{
      let radioButtonValue = e.target.value
      this.selectedCheckboxes.clear()
      this.selectedCheckboxes.add(radioButtonValue)
    }
    const cardSelectCount = this.selectedCheckboxes.size
    const errorMsgstate = cardSelectCount ? false : true
    this.setState({
      errorMsg: errorMsgstate
    })
  }

 

  render() {
    const merchantData = getMerchantData(this.state.merchantName)
    if (this.state.doRedirect === true) {
      if (this.state.pageName === "RaDeny") {
        return <Navigate to={ROUTES.PATH.RaDeny} replace />
      } else if (this.state.pageName === "ContactChannels") {
        return <Navigate to={ROUTES.PATH.ContactChannels} replace />
      } else if (this.state.pageName === "NoContactChannel") {
        return <Navigate to={ROUTES.PATH.NoContactChannel} replace />
      } else if (this.state.pageName === "TechDiff") {
        return <Navigate to={ROUTES.PATH.TechDiff} replace />
      } else if (this.state.pageName === "CardSecurePage") {
        return (<Navigate to={{pathname: ROUTES.PATH.CardSecurePage}}
          carddata={{ carddigits: this.state.singleCardNum }}
          replace 
        />);
      } else if (this.state.pageName === "RedirectPage") {
        return (
          <Navigate to={{pathname: ROUTES.PATH.RedirectPage}}
            state={{ loc: this.state.locationhref }}
            replace
          />
        );
      } else {
        console.log("Route problem")
      }
    } else {
      let isLoadervalue = this.state.isLoaded;
      return (
        <React.Fragment>
           {isLoadervalue ?
               <div className="spinner">
               <img src={spinner} alt="Spinner"/>
             </div> : null
          }
          <div className="row">
            <div className="multicard-blk multicard-logo col-xs-12 col-sm-6 col-md-5 col-lg-3 col-md-offset-3 col-lg-offset-4 col-sm-offset-3">
              <div class="paypal-logo">
                  <Logo merchantName ={this.state.merchantName}/>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="multicard-blk col-xs=12 col-sm-6 col-md-5 col-lg-3 col-md-offset-3 col-lg-offset-4 col-sm-offset-3">
              <p className="multicard-header">{merchantData.MultiCard.HEADER}</p>
            </div>
          </div>
          <div className="row">
            <div className="multicard-blk col-xs=12  col-sm-6 col-md-5 col-lg-3 col-md-offset-3 col-lg-offset-4 col-sm-offset-3" >
              {(this.state.submited && this.state.errorMsg) ? <div className="multicard-errorBlk"><img src={alert} alt={alert} /><p className="multicardText">Please make your selection(s).</p></div> : ""}
            </div>
          </div>
          <div className="row">
            <div className="multicart-blk multicard-blk col-xs-12 col-sm-6 col-md-5 col-lg-3 col-md-offset-3 col-lg-offset-4 col-sm-offset-3">
              <form onSubmit={this.handleFormSubmit} className="multicard-form">
                <div className={(this.state.submited && this.state.errorMsg) ? "multicard multicard-wrap" : "multicard-scrollmul"}>
                  <div className="Line2" />
                  {
                    this.state.eligibleAccountVO.map((eligibleAccountVO) => {
                      let city_state_pin = `${eligibleAccountVO.billingAddress.city}, ${eligibleAccountVO.billingAddress.state} ${eligibleAccountVO.billingAddress.zipCode}`
                      let encodedCardArt = `${eligibleAccountVO.encodedCardArt}`
                      let cardImageName = `${eligibleAccountVO.cardImageName}`
                      let emailAddress = ''
                      let emailAddress1 = ''
                      let emailAddress2 = ''
                      let homePhoneNumber =  ''
                      let primMobileNumber =  ''
                      let workPhoneNumber =  ''
                      if(this.state.merchantName==='amazon'){
                      emailAddress = `${eligibleAccountVO.emailAddress}`
                      if(emailAddress.length >20){
                        emailAddress1 = emailAddress.split("@")[0]
                        emailAddress2 = ("@" + emailAddress.split("@")[1])
                        emailAddress = ""
                      }
                      //to display phone numbers on priority
                      if(`${eligibleAccountVO.primMobileNumber}` !== "" && isRealPhoneNumber(`${eligibleAccountVO.primMobileNumber}`)){
                        primMobileNumber = `${eligibleAccountVO.primMobileNumber}`
                      }
                      else if(`${eligibleAccountVO.homePhoneNumber}` !== "" && isRealPhoneNumber(`${eligibleAccountVO.homePhoneNumber}`)){
                          homePhoneNumber = `${eligibleAccountVO.homePhoneNumber}`
                      }
                      else if(`${eligibleAccountVO.workPhoneNumber}`  !== "" && isRealPhoneNumber(`${eligibleAccountVO.workPhoneNumber}`)){
                          workPhoneNumber = `${eligibleAccountVO.workPhoneNumber}`
                      }
                      }

                      return (

                        <CardDetails
                          key={eligibleAccountVO.accntKey}
                          cardProductTypeDesc={eligibleAccountVO.cardProductTypeDesc}
                          lastFacntnum={eligibleAccountVO.last4AcctNbr}
                          firstName={eligibleAccountVO.firstName}
                          lastName={eligibleAccountVO.lastName}
                          billingAddress1={eligibleAccountVO.billingAddress.addressLine1}
                          billingAddress2={eligibleAccountVO.billingAddress.addressLine2}
                          city_state_pin={city_state_pin}
                          encodedCardArt={encodedCardArt}
                          cardImageName={cardImageName}
                          checkval={this.state.errorMsg}
                          checkboxfun={this.toggleChange}
                          uniqueval={eligibleAccountVO.accntKey}
                          alreadyLinked={eligibleAccountVO.accountAlreadyLinked}
                          merchant = {this.state.merchantName}
                          emailAddress = {emailAddress}
                          emailAddress1 = {emailAddress1}
                          emailAddress2 = {emailAddress2}
                          homePhoneNumber={homePhoneNumber}
                          primMobileNumber={primMobileNumber}
                          workPhoneNumber={workPhoneNumber}
                        />

                      )
                    })

                  }
                </div>
                <div>
                <p className="multicard-footer">{this.state.merchantName == "paypal"? merchantData.MultiCard.MESSAGE : ""}
                  </p>
                </div>
                <div>
                  <p className="consenting-head">
                  {this.state.merchantName != "paypal" ? merchantData.MultiCard.MESSAGE: ""}</p>	 
                </div>
                <div className="row multicard-btn">
                  <button>{merchantData.MultiCard.BUTTON}</button>
                </div>
              </form>
              <div className="row multicard-cancel">
                  <button class="changebtnproperty" onClick={this.handleCancel}>{merchantData.MultiCard.LINK}</button>
                </div>
                <div className="row">
                  <div className="multicard-terms-blk">
                      {this.state.merchantName != "paypal" ? (
                       <div className="termsAndCondition-footer">
                       <p class="termsAndCondition-sub-head">{merchantData.MultiCard.TERMS}
                        {<LinkContent />}
                       </p>
                    </div>
              ) : (
                
                <div className="termsAndCondition-footer">
                  <p class="termsAndCondition-sub-head">{merchantData.MultiCard.TERMS}
                    {<LinkContentPaypal />}
                  </p>
                </div>
              )}
            </div>
          </div>
            </div>
          </div>
        </React.Fragment>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    multiposts: state
  }
}

export default connect(mapStateToProps)(MultiCard);
